import React from "react";
import { Controller } from "react-hook-form";
import { Typography, Stack, TextField, FormControl, FormLabel, Button, Link } from "@mui/material";
import { Tag } from "src/components/Tag";
import Section from "src/components/Section";
import CustomStepper from "src/components/CustomStepper";
import PageHeader from "src/components/PageHeader";
import { useInputPersonalPage } from "./hooks";
import { useLocation, useNavigate } from "react-router";
import { usePersonalStep } from "src/hooks/usePersonalStep";

export default function InputPersonalPage() {
  const { control, errors } = useInputPersonalPage();

  const navigate = useNavigate();
  const location = useLocation();

  const { validatePersonalStep } = usePersonalStep();

  const handleFormSubmit = async () => {
    const isValid = await validatePersonalStep();
    if (isValid) {
      navigate({
        pathname: "/confirm",
        search: location.search,
      });
    }
  };

  return (
    <>
      <PageHeader title="高精度不動産AI査定" px={5}>
        <Typography fontWeight="bold" textAlign="center">
          以下フォームをご入力ください。
          <br />
          不動産ビッグデータを学習した人工知能 ( AI ) による査定価格をお伝えします。
        </Typography>
      </PageHeader>

      {/* フォームセクション */}
      <Section sx={{ pb: 5 }}>
        <Stack spacing={4}>
          <CustomStepper activeStep={1} />

          <Stack spacing={3}>
            <Typography variant="h6" fontWeight="bold">
              お客様情報
            </Typography>

            <FormControl>
              <Stack spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <FormLabel>名前</FormLabel>
                  <Tag label="必須" color="secondary" />
                </Stack>

                <Controller
                  name="last_name"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="山田"
                      error={!!errors.last_name}
                      helperText={errors.last_name?.message}
                    />
                  )}
                />
                <Controller
                  name="first_name"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="太郎"
                      error={!!errors.first_name}
                      helperText={errors.first_name?.message}
                    />
                  )}
                />
              </Stack>
            </FormControl>
            <FormControl>
              <Stack spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <FormLabel>電話番号</FormLabel>
                  <Tag label="必須" color="secondary" />
                </Stack>
                <Controller
                  name="phone_number"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="000-0000-0000"
                      error={!!errors.phone_number}
                      helperText={errors.phone_number?.message}
                    />
                  )}
                />
              </Stack>
            </FormControl>
            <FormControl>
              <Stack spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <FormLabel>メールアドレス</FormLabel>
                  <Tag label="必須" color="secondary" />
                </Stack>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="sample@exsample.com"
                      error={!!errors.email}
                      helperText={errors.email?.message}
                    />
                  )}
                />
              </Stack>
            </FormControl>

            <FormControl>
              <Stack spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <FormLabel>備考</FormLabel>
                  <Tag label="任意" color="info" />
                </Stack>
                <Controller
                  name="remarks"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} placeholder="ご相談内容をご入力ください。" multiline rows={4} />
                  )}
                />
              </Stack>
            </FormControl>
          </Stack>

          <Typography variant="body2" lineHeight={1.5}>
            <Link href="https://propally.co.jp/privacypolicy.html" target="_blank" rel="noopener noreferrer">
              「プライバシーポリシー」
            </Link>
            をよくお読みいただき、ご理解いただける場合は以下のボタンより内容のご確認に進んでください。
          </Typography>

          <Button variant="contained" color="primary" onClick={handleFormSubmit}>
            確認画面へ
          </Button>
          <Button
            fullWidth
            sx={{ backgroundColor: "#B1B1B1" }}
            onClick={() =>
              navigate({
                pathname: "/input_property",
                search: location.search,
              })
            }
          >
            戻る
          </Button>
        </Stack>
      </Section>
    </>
  );
}
